import React, {useEffect, useState} from 'react';
import { getBrandingInfo } from './services/onwardReferralService';
import F2FSelfReferral from '../pharos/F2FSelfReferral';
import toBoolean from '../../lib/iprs-react-library/src/util/toBoolean';

// This component will show the button if 'GetBrandingInfo' response has
// 'InsertF2FSelfReferralButton' and if it set to true.
const F2FReferralButton = ({api, caseID}) => {

    const [showF2FButton, setShowF2FButton] = useState(false)

    useEffect(()=>{
        getBrandingInfo(api, caseID)
            .then(result=>{
                const f2fBoolean = toBoolean(result.Settings.InsertF2FSelfReferralButton);

                if(f2fBoolean){
                    setShowF2FButton(true);
                }else{
                    setShowF2FButton(false);
                }
            })
            .catch(e=>{
                console.log(e)
            });
    },[api, caseID])

    return (
        <div className="clinicSearch">
            {showF2FButton ? <F2FSelfReferral api={api} /> : <></>}
        </div>
    )
}

export default F2FReferralButton; 